import { History } from "lucide-react";
import { ComunicazioniHome } from "./ComunicazioniHome";
import { QuickPrompts } from "./QuickPrompts";
import { StrumentiScorciatoie } from "./StrumentiScorciatoie";
import { useUltimeDomande } from "./UltimeDomande";

type UltimaConversazione = { id: string; title: string };

export function ChatLanding({
  onPick,
  ultima = null,
  onRiprendi,
}: {
  onPick: (p: string) => void;
  /** L'ultima conversazione di oggi, se c'e'. Null se e' vecchia o non esiste. */
  ultima?: UltimaConversazione | null;
  onRiprendi?: (id: string) => void;
}) {
  const { data: ultime = [] } = useUltimeDomande();
  const primaVolta = ultime.length === 0;

  // IL SOTTOTITOLO E' UN ELENCO, E NON PER DECORAZIONE. In riunione (27/08)
  // Umberto ha detto qual e' il problema vero: non la qualita' del motore, ma
  // COME l'installatore pone la domanda - «puoi fare la stessa domanda nel modo
  // sbagliato e avere una risposta diversa». Il rischio non e' che l'app
  // sbagli, e' che sembri rotta quando la domanda era mal posta. Queste cinque
  // parole insegnano il modo giusto di chiedere nel punto in cui si chiede.
  // Il titolo si e' accorciato per fargli spazio (Davide, 27/08 sera).
  //
  // Poco stacco dall'intestazione (Davide, 27/08: «c'e' molto spazio fra il
  // titolo e l'header, qualche pixel si puo' recuperare»). Su un telefono quei
  // pixel sono schermo utile: sopra il titolo si passa da 56 a 24, contando
  // anche il margine che mette la pagina. Sui monitor resta il centraggio
  // verticale, dove lo spazio non manca.
  return (
    <div className="mx-auto flex w-full max-w-2xl flex-col items-center justify-center gap-6 px-4 pb-8 pt-4 text-center">
      <div className="space-y-2.5 animate-fade-up">
        <h1 className="text-balance text-[26px] font-semibold leading-tight tracking-tight text-foreground sm:text-4xl">
          Come posso aiutare?
        </h1>
        <p className="text-balance text-sm text-muted-foreground sm:text-base">
          Alimentazione, morsetti, schemi, configurazione, anomalie.
        </p>
      </div>

      {/* «Riprendi dove eri rimasto», e solo se c'e' davvero dove riprendere.
          Fino al 27/08 mattina l'app ci andava DA SOLA, e questa schermata non
          la vedeva piu' nessuno: un invito di una riga fa lo stesso lavoro
          senza portare via l'installatore da dove voleva essere. */}
      {ultima && onRiprendi && (
        <button
          type="button"
          onClick={() => onRiprendi(ultima.id)}
          className="group -mt-3 inline-flex max-w-full items-center gap-2 rounded-full border border-border/70 bg-surface/60 px-3.5 py-2 text-[13px] text-muted-foreground transition-colors hover:border-primary/50 hover:text-foreground animate-fade-up"
        >
          <History className="h-4 w-4 shrink-0 text-primary" />
          <span className="shrink-0">Riprendi</span>
          <span className="truncate font-medium text-foreground">{ultima.title}</span>
        </button>
      )}

      {/* Le comunicazioni di Datacom aprono la schermata: novita' e promo che
          Umberto pubblica devono farsi vedere SUBITO (Davide, 26/08 — questa
          richiesta scavalca l'ordine del 24/07 che le voleva in fondo). */}
      <div className="w-full animate-fade-up" style={{ animationDelay: "60ms" }}>
        <ComunicazioniHome />
      </div>
      {/* Gli strumenti in vista: stavano solo nel menu laterale e nessuno li
          trovava (Davide, 26/08). */}
      <div className="w-full animate-fade-up" style={{ animationDelay: "90ms" }}>
        <StrumentiScorciatoie />
      </div>
      {/* Le «ultime domande» non ci sono piu' (Davide, 27/08): «bisogna avere
          piu' spazio libero sulla home». Riproponevano tre domande gia' fatte,
          e sulla stessa schermata c'e' gia' il pulsante che riporta all'ultima
          conversazione — dove quelle domande stanno, con le loro risposte.
          Il gancio serve ancora, ma solo per capire chi entra la prima volta. */}
      {primaVolta && (
        <div className="w-full animate-fade-up" style={{ animationDelay: "150ms" }}>
          <QuickPrompts onPick={onPick} />
        </div>
      )}
    </div>
  );
}